import Header from "../fontend/components/Header";
import Footer from "../fontend/components/Footer";

const FrontLayout = ({ children }) => {
  return (<>
    <Header />
    {children}
    <Footer />
  </>);
}

export default FrontLayout;